export enum CellEditType {
    None = 0,
    Text = 1,
    Number = 2,
    Date = 3,
    DateAdd = 4,
    YesNo = 5,
    Money = 6
}

export enum CellFormat {
    Text = 1,
    Number = 2,
    Date = 3,
    YesNo = 5,
    Money = 6
}



// WEBPACK FOOTER //
// ./src/app/components/Grid/CellEditType.ts